export const MOBILE_PROMOS_LIMIT = 5;
